export default __webpack_public_path__ + "static/media/IconAddressWork.c7c8128e.svg";